import React, { useMemo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
// formating table
import * as columnFormatters from "./column-formatter";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

// Metronic helper to done sorting-table ,select row etc.
import {
  getHandlerTableChange, sortCaret,
} from "../../../_metronic/_helpers";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../_metronic/_partials/controls";
// import * as uiHelpers from "../UserUIHelper";
import GlobalLoader from "../../../common/loaders/LoadingBox";
import { exportMerchats, fetchWpMerchants, resetLoading } from "../../../actions/merchants/merchants";
import { useMerchantUIContext } from "../MerchantUIContext";
import { Formik } from "formik";
import Fuse from "fuse.js";
import { API_END_POINTS } from "../../../constant/config";

export function WPMerchantTable({tabValues}) {

  const [loader, setLoader] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [exportLoading, setExportLoading] = useState(false);

  const { wpMerchants } = useSelector(
    (state) => ({
      wpMerchants:
        state.merchants && state.merchants.wpMerchants && state.merchants.wpMerchants.docs,
    }),
    shallowEqual
  );

  const { count } = useSelector(
    (state) => ({
      count:
      state.merchants && state.merchants.wpMerchants && state.merchants.wpMerchants.totalDocs,
    }),
    shallowEqual
  );

  const fuse = new Fuse(wpMerchants?wpMerchants:[],
    {keys:["plugin_status"],
    useExtendedSearch: true})

   const results = fuse.search(`=${filterText}`)

   const serchedResult = filterText ? results.map((result) => result.item) : wpMerchants ? wpMerchants : [];
  const dispatch = useDispatch();

  const merchantUIContext = useMerchantUIContext();
  const merchantUIProps = useMemo(() => {
    return {
      ids: merchantUIContext.ids,
      setIds: merchantUIContext.setIds,
      queryParams: merchantUIContext.queryParams,
      setQueryParams: merchantUIContext.setQueryParams,
      openEditMerchantPage: merchantUIContext.openEditMerchantPage,
      openDeleteMerchantDialog: merchantUIContext.openDeleteMerchantDialog,
      sendEmailMerchant: merchantUIContext.sendEmailMerchant,
      openViewMerchantDialog: merchantUIContext.openViewMerchantDialog,
    };
  }, [merchantUIContext]);

  useEffect(() => {

    merchantUIProps.setQueryParams({
      ...merchantUIProps.queryParams,
      filter: {
        name: "",
      },
      pluginStatus:"",
      search: "",
      sortOrder: "desc", // asc||desc
      sortField: "date",
      pageNumber: 1,
      pageSize: 10,
    })

  }, []);

  useEffect(() => {

    async function getMerchants () {
      setLoader(true);

      dispatch(resetLoading());
      await dispatch(fetchWpMerchants(merchantUIProps.queryParams));
      
      setLoader(false);
    }

    getMerchants();
  }, [merchantUIProps.queryParams, dispatch]);

  
  const downloadFile = async () => {
    setLoader(true);
    setExportLoading(true);
    let merchantsExportURL = API_END_POINTS.WP_MERCHANTS_EXPORT;
    dispatch(exportMerchats(merchantsExportURL)).then(async (data) => {
      if (data && data.payload) {
        const anchor = document.createElement("a");
        anchor.setAttribute("href", merchantsExportURL);
        anchor.click();
        URL.revokeObjectURL(merchantsExportURL);
        setLoader(false);
        setExportLoading(false);
      } else {
        setLoader(false);
        setExportLoading(false);
      }
    });
  }

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "60px" },
    },
    {
      dataField: "user_id",
      text: "User Id",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "110px" },
    },
    {
      dataField: "store_url",
      text: "Store URL",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "100px" },
      // formatter: columnFormatters.WPstoreUrlFormatter,
    },
    {
      dataField: "user_email",
      text: "Email",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
      formatter: columnFormatters.EmailColumnFormatter,
    },
    {
      dataField: "user_email2",
      text: "Email-2",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
      formatter: columnFormatters.EmailColumnFormatter,
    },
    {
      dataField: "plan_detail",
      text: "Purchase Plan Name",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "170px" },
    },
    {
      dataField: "plugin_status",
      text: "Plugin Install Status",
      style: { minWidth: "170px" },
      sort: false,
      // sortCaret: sortCaret,
      // formatter: columnFormatters.StatusColumnFormatter,

    },
    {
      dataField: "pulgin_install_date",
      text: "Date Added",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.WPDateColumnFormatter,
      style: {
        minWidth: "120px",
      },
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.WPActionsColumnFormatter,
      formatExtraData: {
        openEditMerchantPage: merchantUIProps.openEditMerchantPage,
        openViewMerchantDialog: merchantUIProps.openViewMerchantDialog,
        sendEmailMerchant: merchantUIProps.sendEmailMerchant,
        tabValues:tabValues
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-1",
      style: {
        minWidth: "170px",
      },
    },
  ];

  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
  ];
  
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: count === null ? 0 : count,
    sizePerPageList: sizePerPageList,
    sizePerPage: merchantUIProps.queryParams.pageSize,
    page: merchantUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <Formik
        initialValues={{
          searchText: "",
          pluginStatus:"",
        }}
        onSubmit={(values) => {
          merchantUIProps.setQueryParams({
            ...merchantUIProps.queryParams,
            search: values.searchText,
            pluginStatus: values.plugin_status,
            pageNumber:1,
            pageSize:10
          })
        }}
      >
        {({ values, handleSubmit, handleBlur, handleChange, setFieldValue }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-7">
                <div className="input-icon">
                  <input
                    type="text"
                    className="form-control"
                    name="searchText"
                    placeholder="Search..."
                    onBlur={handleBlur}
                    value={values.searchText.trim()}
                    onChange={(e) => {
                      setFieldValue("searchText", e.target.value.trim());
                      handleSubmit();
                    }}
                  />
                  <span>
                    <i className="flaticon2-search-1 text-muted"></i>
                  </span>
                </div>
              </div>

              <div className='col-lg-3'>
                <select
                  className='form-control'
                  name='plugin_status'
                  placeholder='Filter by Plugin install status'
                  onChange={(e) => {
                    setFieldValue("plugin_status", e.target.value);
                    setFilterText(e.target.value)
                    handleSubmit()
                  }}
                  onBlur={handleBlur}
                  value={values.status}>
                  <option value=''>All</option>
                  <option value='activated'>Activated</option>
                  <option value='deleted'>Deleted</option>
                </select>
                <small className='form-text text-muted'>
                  Filter by Plugin install status
                </small>
              </div>

              <div className='col-lg-2 text-right'>
                <button type="button" className="btn btn-primary" onClick={() => downloadFile()} disabled={exportLoading}>
                  <i className="fa fa-file-export"></i> {exportLoading ? "Exporting..." : "Export"}
                </button>
              </div>

            </div>  
          </form>
        )}
      </Formik>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses='table-responsive '
                classes='table table-head-custom table-vertical-center'
                bootstrap4
                bordered={false}
                remote
                keyField='id'
                columns={columns}
                // data={products}
                data={serchedResult ? serchedResult : []}
                onTableChange={getHandlerTableChange(
                  merchantUIProps.setQueryParams
                )}
                {...paginationTableProps}
                noDataIndication={() => serchedResult===null ? '' : <div className="no-data-indication">No records found</div>}
              >
              </BootstrapTable>
              {loader &&  <GlobalLoader />}
            </Pagination>
          );
        }}
      </PaginationProvider>

    </>
  );
}
